import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BaseApiService } from '@carm/_core/baseapi.service';
import * as dayjs from 'dayjs';
import { Observable } from 'rxjs';
import { dateFormat } from '@carm/shared/constants/const-carm';
import { IBrokerSummaryResponse } from '../models';
import { LoaderSpinnerTypes } from '@carm/_core';

@Injectable()
export class BrokerSummaryService extends BaseApiService {

  get brokerSummaryEndpointB(): string {
    return `${this.endPointB}/financial/broker-summary`;
  }

  constructor(protected injector: Injector) {
    super(injector);
  }

  public getBrokerSummaryList(
    searchString: string,
    minDate: Date,
    maxDate: Date,
    sort: string,
    currentPage: number,
    pageSize: number
  ): Observable<IBrokerSummaryResponse> {
    const params = new HttpParams()
      .set('currentPage', currentPage ? currentPage.toString() : '1')
      .set('pageSize', pageSize.toString())
      .set('startDate', dayjs(minDate).format(dateFormat))
      .set('endDate', dayjs(maxDate).format(dateFormat))
      // .set('startDate', '2020-01-01')
      .set('searchString', searchString);
    const endPoint = `${this.brokerSummaryEndpointB}/list`;
    return this.httpAuthGet<IBrokerSummaryResponse>(endPoint, params, LoaderSpinnerTypes.AgGrid);
  }

  public downloadBrokerSummary(CACorrespondence: string, arcDocId: string): Observable<any> {
    const endPoint = `${this.brokerSummaryEndpointB}/download?arcDocId=${arcDocId}&caCorrespondence=${CACorrespondence}`;
    return this.httpAuthGet<any>(endPoint);
  }
}
